// Guest names go to the hotel supplier exactly as entered, and ETG rejects
// anything outside plain Latin letters (it refused "(e2e audit)" only after
// the payment had been taken). Check names before payment, using the same
// rule as the server: Latin letters, spaces, hyphens, apostrophes and dots,
// as printed in the passport's machine-readable line.

const GUEST_NAME = /^[A-Za-z][A-Za-z .'-]*$/;
const MAX_LENGTH = 100;

// Phone keyboards insert a typographic apostrophe (O’Brien); send the plain one.
export function normalizeGuestName(value: string): string {
  return value.replace(/[‘’ʼ]/g, "'").replace(/\s+/g, ' ').trim();
}

/** Why a guest name cannot be sent to the hotel, or null when it can. */
export function guestNameProblem(value: string): string | null {
  const name = normalizeGuestName(value);
  if (!name) return 'Required';
  if (name.length > MAX_LENGTH) return `Use at most ${MAX_LENGTH} characters`;
  if (!GUEST_NAME.test(name)) return 'Use Latin letters (A–Z) as on the passport. Spaces, hyphens and apostrophes are fine.';
  return null;
}
